const TelegramIcon = (props) => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.333 10C0.333 4.477 4.81 0 10.333 0C15.856 0 20.333 4.477 20.333 10C20.333 15.523 15.856 20 10.333 20C4.81 20 0.333 15.523 0.333 10ZM14.883 6.333L13.383 13.667C13.383 13.667 13.167 14.25 12.5 13.958L9.5 11.625L8.333 11.042L6.167 10.375C6.167 10.375 5.833 10.25 5.833 9.958C5.833 9.667 6.183 9.542 6.183 9.542L14.167 6.292C14.167 6.292 14.883 5.958 14.883 6.333ZM9.167 13.292C9.167 13.292 9.1 13.283 9.017 13.208L9.45 11.583L12.833 9.333C12.833 9.333 13.017 9.208 13 9.333C13 9.333 12.95 9.375 12.833 9.5L10 11.917L9.167 13.292Z"
                fill="white"
            />
        </svg>
    );
};

export default TelegramIcon;
